import React, {useState} from 'react';
import {useAppSelector} from "../DAL/store";
import CreatorDetails from "../components/creator-details";
import {useWindowSize} from "../../../../domain/common";
import CreatorDetailsMobile from "../components/creator-details-mobile";
import Preset from "../../common/components/preset";
import RightArrowIcon from "../../common/svg/right-arrow";
import {Popup} from "../../../../ui/popup/popup";
import {MAX_MOBILE_SIZE} from "../../common/constants";


/**
 * the entry point
 */
const App: React.FC = () => {
    const [showLinkCopiedPopup, setShowLinkCopiedPopup] = useState(false);

    const PublicCreatorProfileData = useAppSelector((store) => store.PublicCreatorProfileData);
    const size = useWindowSize();
    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const creatorsPath = useAppSelector((store) => store.creatorsPath);

    return (
        <div className="waves-box-ml mx-auto text-left px-5 md:px-12 xl:px-0">
            {size.width !== undefined && size.width > MAX_MOBILE_SIZE ?
                <CreatorDetails  />
                :
                <CreatorDetailsMobile  />
            }
            {PublicCreatorProfileData.presets.length > 0 && <div className="w-full border-b border-b-gray-600 my-6"></div>}

            <div className="flex items-center justify-between text-center mt-8">
                {PublicCreatorProfileData.presets.length > 0 && <div className="waves-h3 font-bold pb-0 mt-0">Creator Chains</div>}
                {PublicCreatorProfileData.presets.length >= 8 &&
                    <a className="flex items-center justify-center text-black"
                       href={"/studioverse/creator/chains/" + PublicCreatorProfileData.profile.handle.toLowerCase()}>
                        <span className="pr-2 font-medium">View All Chains</span>
                        <RightArrowIcon width={"7px"} color="black"/>
                    </a>
                }
            </div>
            {PublicCreatorProfileData.presets.length > 0 &&
                <div className="w-full mt-2 mb-6 lg:w-3/4">
                    Hear chains on your tracks when you <span className="font-bold">drag & drop</span> or <span className="font-bold">copy & paste</span> chain links from the web directly into StudioRack, inside your DAW of choice.
                    <a className="text-black pl-2" href="/studioverse/about">Learn more</a>

                </div>
            }

            <div className="w-full mt-6">
                <ul className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-12">
                    {PublicCreatorProfileData.presets.map((preset,index) => {
                        const presetTags = PublicCreatorProfileData.presetTags.filter(tag => tag.presetID === preset.presetID);
                        return <li className="grid-item" key={preset.presetID + "_" + index}>
                                    <Preset preset={preset} profile={PublicCreatorProfileData.profile} presetTags={presetTags} imgCdnDomain={imgCdnDomain} creatorsPath={creatorsPath} setShowLinkCopiedPopup={setShowLinkCopiedPopup} />
                                </li>
                    })}
                </ul>
            </div>
            {showLinkCopiedPopup && <Popup classes="py-10" close={() => setShowLinkCopiedPopup(false)}>
                <div className="ok-box" role="alert">The link was copied to clipboard</div>
            </Popup>}
            {PublicCreatorProfileData.presets.length >= 8 &&
                <div className="w-full flex items-center justify-center my-12 md:my-16">
                    <a className="w-btn py-3 px-8 w-auto font-normal flex items-center"
                       href={"/studioverse/creator/chains/" + PublicCreatorProfileData.profile.handle.toLowerCase()}>
                        <span className="pr-2 font-normal">View All {PublicCreatorProfileData.profile.publicName}'s Chains</span>
                        <RightArrowIcon width={"7px"} color="white"/>
                    </a>
                </div>
            }
        </div>

    );
};

export default App;

